<template>
    <v-btn @click="onClick" color="primary"><v-icon class="mr-2">add</v-icon>
        <slot>Add New</slot>
    </v-btn>
</template>

<script>
export default {
    methods: {
        onClick() {
            this.$emit('click');
        }
    }
}
</script>